import { Link } from 'react-router-dom'

import { IconArrowLeftSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

type SubHeader = {
  name?: string | undefined
  cpf?: string
  page?: string
  link?: string
}

const SubHeader = ({
  cpf = '000.000.000-00',
  name,
  link = '/',
  page = 'Home'
}: SubHeader) => (
  <S.Wrapper className="no-print">
    <S.Content>
      <Link to={link}>
        <IconArrowLeftSvg />
        {page}
      </Link>
      {cpf && name && (
        <>
          <span>|</span>
          <h4>
            <b> Paciente: </b>
            {name}
          </h4>
          <span>|</span>
          <h4>
            <b>CPF: </b>
            {cpf}
          </h4>
        </>
      )}
    </S.Content>
  </S.Wrapper>
)

export default SubHeader
